<template>
  <div class="tab-text client-table">
    <div class="vx-row mb-4">
      <div class="vx-col sm: w-full md:w-1/2 mt-4 set_limit">
        <label class="limit_label">{{ $t("labels.show") }}</label>
        <v-select v-model="limit" :options="limitarr" :reduce="(limitarr) => limitarr.value" :clearable="false"
          label="text" class="px-1" />
        <label class="limit_label">{{ $t("labels.clients") }}</label>
      </div>
      <div class="vx-col sm: w-full md:w-1/2">
        <div class="mt-4 float-right flex">
          <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-filter"
            @click="showfilter = !showfilter" class="mr-2 btn-color">{{ $t("labels.filter") }}</vs-button>
          <vs-button color="dark" type="filled" icon-pack="feather" icon="icon-upload" class="ml-4 btn-color"
            @click.prevent="exportCsv()">{{ $t("labels.export") }}</vs-button>
        </div>
      </div>
    </div>
    <vx-card class="filter-card filter_card" v-show="showfilter == true">
      <div class="vx-row filter-default">
        <div class="vx-col md:w-1/5">
          <label class="pl-1">{{ $t("labels.search") }}</label>
          <vs-input icon-pack="feather" icon="icon-search" v-model="search" class="w-full" />
        </div>
        <div class="vx-col sm: w-full md:w-1/4">
          <label class="pl-1">{{ $t("labels.subtype") }}</label>
          <v-select v-model="subtypes" :options="filterSubtype" :reduce="(filterSubtype) => filterSubtype.value"
            label="label" class="filter-dropdown" />
        </div>
        <div class="vx-col sm: w-full md:w-1/5">
          <label class="pl-1">{{ $t("labels.block_unblock") }}</label>
          <v-select v-model="block" :options="filterBlock" :reduce="(filterBlock) => filterBlock.value" label="text"
            class="filter-dropdown" />
        </div>
        <div class="vx-col sm: w-full md:w-1/3 flex mt-5">
          <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-filter" :title="$t('labels.filter')"
            @click.prevent="filter()" :disabled="!this.search && this.block && !this.block && !this.subtypes
              " class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn">{{ $t("labels.filter") }}</vs-button>
          <vs-button color="maroon" type="filled" icon-pack="feather" icon="icon-x" :title="$t('labels.filter')"
            @click="clearFilter()" :disabled="!this.search && this.block && !this.block && !this.subtypes
              " class="sm:ml-0 md:ml-4 px-10 btn-color fltr-btn">{{ $t("labels.clear") }}</vs-button>
        </div>
      </div>
    </vx-card>
    <vs-table :data="clients" class="permission">
      <template slot="thead">
        <vs-th class="col-md-3">{{ $t("labels.name") }}</vs-th>
        <vs-th class="col-md-3">{{ $t("labels.email") }}</vs-th>
        <vs-th v-if="canViewOrganisations" class="col-md-2">{{ $t("labels.organisation_name") }}</vs-th>
        <vs-th class="col-md-2">{{ $t("labels.subtype") }}</vs-th>
        <vs-th class="col-md-2">{{ $t("labels.action") }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"
          v-bind:class="[tr.is_blocked == 1 ? 'user-table' : '']">
          <vs-td :data="tr.username">
            <router-link class="view-link" :to="{ name: 'ViewUser', params: { id: tr.id } }"
              v-if="checkPermission('user', 'view')">{{ tr.name }}</router-link>
          </vs-td>
          <vs-td :data="tr.email">{{ tr.email }}</vs-td>
          <vs-td v-if="canViewOrganisations" :data="tr.organisation_id">
            {{ getOrganisationName(tr.organisation_id) || '-' }}
          </vs-td>
          <vs-td :data="tr.sub_type_name">{{ tr.sub_type_name }}</vs-td>
          <vs-td width="200">
            <div class="flex">
              <router-link class="view-link" :to="{ name: 'ViewUser', params: { id: tr.id } }"
                v-if="checkPermission('user', 'view')">
                <vs-button type="flat" :title="$t('labels.view')" size="large" icon-pack="feather" icon="icon-eye"
                  class="btn-icon" color="dark"></vs-button>
              </router-link>
              <router-link class="view-link" :to="{ name: 'EditUser', params: { id: tr.id } }"
                v-if="checkPermission('user', 'modify')">
                <vs-button type="flat" :title="$t('labels.edit')" size="large" icon-pack="feather" icon="icon-edit"
                  color="success" class="btn-icon"></vs-button>
              </router-link>

              <vs-button @click="deleteConfirm(indextr)" type="flat" :title="$t('labels.delete')" size="large"
                icon-pack="feather" icon="icon-trash-2" color="danger" class="btn-icon"
                v-if="checkPermission('user', 'delete')">
              </vs-button>
              <vs-button @click="blockConfirm(indextr)" type="flat" :title="!tr.is_blocked ? $t('labels.block') : $t('labels.unblock')
                " size="large" icon-pack="feather" :icon="!tr.is_blocked ? 'icon-lock' : 'icon-unlock'"
                :color="!tr.is_blocked ? 'warning' : 'dark'" v-if="checkPermission('user', 'modify')"
                class="btn-icon"></vs-button>

              <vs-button type="flat" :title="$t('labels.reset_pass_button')" size="small" class="key-icon btn-icon"
                color="success" @click="resetPassConfirm(indextr)" v-if="checkPermission('user', 'modify')">
                <key-icon size="2x" class="custom-class" color="maroon"></key-icon>
              </vs-button>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="float-right mt-6">
      <vs-pagination color="dark" :total="$store.state.userData.clientCount" v-model="currentx" class="mb-1">
      </vs-pagination>
    </div>
  </div>
</template>

<script>
import { KeyIcon } from "vue-feather-icons";
import { EventBus } from "@/mixins/mixin.js";

export default {
  data() {
    return {
      currentx: this.$store.state.userData.clientCurrent,
      // limit: parseInt(process.env.VUE_APP_PER_PAGE),
      limit: this.$store.state.limit,
      showfilter: false,
      search: this.$store.state.userData.clientSearch,
      subtypes: this.$store.state.userData.clientSubtype,
      block: this.$store.state.userData.clientBlock,
      filterSubtype: [
        { label: "Owner", value: "OW" },
        { label: "Manager", value: "M" },
        { label: "Office", value: "OF" },
        { label: "Fleet", value: "F" },
      ],
      filterBlock: [
        { text: this.$t("labels.block"), value: true },
        { text: this.$t("labels.unblock"), value: false },
      ],
      organisations: [],
    };
  },
  mounted() {
    if (localStorage.getItem("limit")) {
      this.limit = localStorage.getItem("limit");
    }
    if (
      this.$store.state.userData.clientSearch ||
      this.$store.state.userInfo.clientSubtype ||
      this.$store.state.userData.clientBlock
    ) {
      this.showfilter = true;
    }
    if (this.$store.state.userInfo.subtype === "M") {
      this.filterSubtype.splice(0, 1);
    } else if (this.$store.state.userInfo.subtype === "OF") {
      this.filterSubtype.splice(0, 2);
    } else if (this.$store.state.userInfo.subtype === "F") {
      this.filterSubtype.splice(0, 3);
    }
    this.$store.commit("UPDATE_TAB", 1);
    if (this.isUserType("A")) {
      this.fetchOrganisations();
    }
  },
  watch: {
    currentx(val) {
      this.$store.commit("updateClientCurrent", val, { module: "userData" });
      EventBus.$emit("pageChanged", "CL");
    },
    limit(val) {
      localStorage.setItem("limit", val);
      this.$store.commit("updateClientLimit", val, { module: "userData" });
      this.currentx = 1;
      EventBus.$emit("limitChanged", "CL");
    },
  },
  components: {
    KeyIcon,
  },
  computed: {
    clients() {
      return this.$store.state.userData.clients;
    },
    canViewOrganisations() {
      return this.isUserType("A") || false;
    },
  },
  methods: {
    deleteConfirm(indextr) {
      EventBus.$emit("deleteConfirm", indextr);
    },
    blockConfirm(indextr) {
      EventBus.$emit("blockConfirm", indextr);
    },
    resetPassConfirm(indextr) {
      EventBus.$emit("resetPassConfirm", indextr);
    },
    exportCsv() {
      EventBus.$emit("export", "CL");
    },
    filter() {
      this.$store.commit("updateClientSearch", this.search, {
        module: "userData",
      });
      this.$store.commit("updateClientBlock", this.block, {
        module: "userData",
      });
      this.$store.commit("updateClientSubtype", this.subtypes, {
        module: "userData",
      });
      EventBus.$emit("filter", "CL");
    },
    clearFilter() {
      this.search = null;
      this.subtypes = null;
      this.block = null;
      this.$store.commit("updateClientSearch", null, {
        module: "userData",
      });
      this.$store.commit("updateClientBlock", null, {
        module: "userData",
      });
      this.$store.commit("updateClientSubtype", null, {
        module: "userData",
      });
      EventBus.$emit("filter", "CL");
    },
    async fetchOrganisations() {
      try {
        let response = await this.getHTTPPostResponse('/organizations/list');
        this.organisations = response.data.organizations; // Adjust based on API structure
      } catch (error) {
        console.error("Failed to fetch organisations", error);
      }
    },
    getOrganisationName(orgId) {
      const org = this.organisations.find(o => o.id === orgId);
      return org ? org.name : null;
    },
  },
};
</script>
<style scoped>
.btn-icon {
  width: 30px !important;
  height: 30px !important;
  padding: 16px !important;
}
</style>
